<template>
  <div v-if="!startLoading" class="config-component-block">
    <div class="stats-top">
      Зарегистрировано в системе <span>{{ stats.cars }}</span> автомобиля и <span>{{ stats.carriers }}</span>
      перевозчиков
    </div>
    <div class="stats-flex">
      <div class="stats-widget">
        <div
            class="donut"
            :style="'background: conic-gradient(#DDE5ED 0 '
            + (360 - stats.active_cars / stats.cars * 360)
            + 'deg, #2C5697 '
            + (360 - stats.active_cars / stats.cars * 360)
            + 'deg 360deg)'"
        >
          <div class="donut-text">
            {{ stats.active_cars }}
          </div>
        </div>
        Активных ТС
      </div>
      <div class="stats-widget">
        <div
            class="donut"
            :style="'background: conic-gradient(#DDE5ED 0 '
            + (360 - stats.inactive_cars / stats.cars * 360)
            + 'deg, #2C5697 '
            + (360 - stats.inactive_cars / stats.cars * 360)
            + 'deg 360deg)'"
        >
          <div class="donut-text">
            {{ stats.inactive_cars }}
          </div>
        </div>
        Неактивных ТС
      </div>
      <div class="stats-widget">
        <div
            class="donut"
            :style="'background: conic-gradient(#DDE5ED 0 '
            + (360 - stats.active_users / stats.users * 360)
            + 'deg, #2C5697 '
            + (360 - stats.active_users / stats.users * 360)
            + 'deg 360deg)'"
        >
          <div class="donut-text">
            {{ stats.active_users }}
          </div>
        </div>
        Активных пользователей
      </div>
    </div>
  </div>
  <LoadingSpinner v-else/>
</template>

<script>

import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "ConfigurationStatsView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push('/login');
    }
    if (!store.state.user.roles.includes('ROLE_CONFIG')) {
      this.$router.push('/');
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      this.fetchStats();
    }
  },
  data() {
    return {
      stats: {},
      startLoading: false,
    };
  },
  components: {
    LoadingSpinner,
  },
  methods: {
    async fetchStats() {
      try {
        this.startLoading = true;
        const response = await http.get('/api/rest/stats');
        if (response.data !== null && response.status === 200) {
          this.stats = response.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
  }
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.config-component-block {
  padding: 15px 53px;
  border-top: 1px solid #DDE5ED;
}

.stats-top {
  font-size: 18px;
  color: #4D5460;
  margin-bottom: 30px;
}

.stats-top span {
  color: #005291;
  font-family: OpenSansSemiBold, sans-serif;
}

.stats-flex {
  display: flex;
}

.stats-widget {
  margin: 0 20px;
  text-align: center;
  width: 185px;
  font-size: 14px;
  color: #4D5460;
}

/*donuts*/
.donut {
  position: relative;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto 12px auto;
}

.donut-text {
  top: 25px;
  left: 25px;
  width: 100px;
  height: 100px;
  background: #fff;
  position: absolute;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 27px;
  color: #075392;
  z-index: 3;
}

</style>